import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogRef,
} from '@angular/material/dialog';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { HelpMenuData } from 'app/core/models/help-centre/help-centre';
import { HelpCentreService } from 'app/core/services/help-centre/help-centre.service';
import { DialogCloseButtonComponent } from '../dialog-close-button/dialog-close-button.component';
import { WhatsNewDialogComponent } from '../whats-new-dialog/whats-new-dialog.component';

@Component({
  selector: 'sqep-help-dialog',
  imports: [
    MatIconModule,
    MatDividerModule,
    MatTooltipModule,
    DialogCloseButtonComponent,
  ],
  templateUrl: './help-dialog.component.html',
  styleUrl: './help-dialog.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HelpDialogComponent {
  private readonly dialogRef = inject(MatDialogRef<HelpDialogComponent>);
  private readonly helpCentre = inject(HelpCentreService);
  private readonly dialog = inject(MatDialog);
  protected readonly data = inject<HelpMenuData>(MAT_DIALOG_DATA);

  close(): void {
    this.dialogRef.close();
  }

  openGuide(): void {
    this.helpCentre.openArticle(this.data.guideSlug);
    this.close();
  }

  openWhatsNew(): void {
    this.dialog.open(WhatsNewDialogComponent, {
      width: '520px',
      maxHeight: '94vh',
      panelClass: 'whats-new-panel',
    });
  }

  protected formatSlug(slug: string): string {
    return slug
      .split('-')
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ');
  }
}
